export const returnMessageMixin = {
  methods: {
    logMessage(res) {
      this.$toasted.show(`<i class="fas fa-check-circle"></i> ${res.data.message}`, {
        theme: 'toasted-primary',
        type: 'success',
        position: 'top-right',
        duration: 5000,
      });
    },
    sliceIntoChunks(arr, chunkSize) {
      const res = [];
      for (let i = 0; i < arr.length; i += chunkSize) {
        const chunk = arr.slice(i, i + chunkSize);
        res.push(chunk);
      }
      return res;
    },
    logMessageWarning(res) {
      this.$toasted.show(`<i class="fas fa-check-circle"></i> ${res.data.message}`, {
        theme: 'toasted-primary',
        type: 'info',
        position: 'top-right',
        duration: 5000,
      });
    },
    logMessageFailed(error) {
      let errorMessage;
      const errorsKeys = Object.keys(error.data.errors || []);
      if (error.data.errors && errorsKeys.length > 0) {
        errorMessage = error.data.errors[errorsKeys[0]][0];
      } else {
        errorMessage = error.data.message;
      }
      this.$toasted.show(`<i class="fas fa-check-circle"></i> ${errorMessage}`, {
        theme: 'toasted-primary',
        type: 'error',
        position: 'top-right',
        duration: 5000,
      });
    },
    logMessageCustom(message) {
      this.$toasted.show(`<i class="fas fa-check-circle"></i> ${message}`, {
        theme: 'toasted-primary',
        type: 'success',
        position: 'top-right',
        duration: 5000,
      });
    },
  },
};
